import React from 'react';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import 'rc-dropdown/assets/index.css';
import DropdownContent from './DropdownContent/DropdownContent';

const SelectMenu = ({ seleccionados, cambiarEstadoFn, estados, siguientes, tiposPlastico }) => {
    return (
    <Menu onSelect={() => { }} selectedKeys={[]} className="DeliveryTarjetasContainer-MenuDropdownEstado">
        <DropdownContent
            seleccionados={seleccionados}
            cambiarEstadoFn={cambiarEstadoFn}
            estados={estados}
            siguientes={siguientes}       
            tiposPlastico={tiposPlastico}
        />
    </Menu>
    );
}

const CambiarEstadoDropdown = ({ active, data, cambiarEstadoFn, estados, siguientes, tiposPlastico }) => {

    if (active <= 0)
        return (
        <button className="btn btn-primary disabled" type="button">
            Cambiar estado
       </button>
       );

    return (
    <Dropdown
      trigger={['click']}
            overlay={<SelectMenu seleccionados={data} cambiarEstadoFn={cambiarEstadoFn} estados={estados} siguientes={siguientes} tiposPlastico={tiposPlastico} />}
      animation="slide-up"
    >
       <button className="btn btn-primary" type="button">
          Cambiar estado
      </button>
    </Dropdown>
    );

}

export default CambiarEstadoDropdown;
